angular.module('picmonicng').factory('FactEditModal', [
  '$modal',
  function ($modal) {
    return {
      open: function (card_id, fact, callback) {
        return $modal.open({
          templateUrl: '/templates/modals/learn-add-fact.html',
          windowClass: 'learn-light-modal below-nav add-fact-modal',
          backdropClass: 'below-nav',
          controller: [
            '$scope',
            '$modalInstance',
            'ClassificationService',
            'Picmonics',
            'FactsResource',
            'UserService',
            'toaster',
            function ($scope, $modalInstance, ClassificationService, Picmonics, FactsResource, UserService, toaster) {
              $scope.ClassificationService = ClassificationService;
              $scope.UserService = UserService;

              $scope.oldFact = fact ? fact : {};
              $scope.fact = fact ? angular.copy(fact) : {};

              $scope.addFact = function () {
                if (!$scope.loading) {
                  $scope.loading = true;

                  if ($scope.fact.fact_id) {
                    $scope.fact.resource = 'facts';
                    $scope.fact.resource_id = $scope.fact.fact_id;
                    $scope.fact.display_name = $scope.fact.name;

                    $scope.fact
                      .$update()
                      .then(function (fact) {
                        if (typeof callback == 'function') {
                          callback(fact);
                        }

                        for (a in fact) {
                          $scope.oldFact[a] = fact[a];
                        }

                        $scope.close();
                      })
                      .finally(function () {
                        $scope.loading = false;
                      });
                  } else {
                    $scope.fact.card_id = card_id;
                    $scope.fact.resource = 'facts';
                    $scope.fact.picmonic = ' ';

                    Picmonics.save($scope.fact)
                      .$promise.then(function (fact) {
                        if (typeof callback == 'function') {
                          callback(fact);
                        }
                        toaster.success('', 'Fact Added!', {
                          positionClass: 'toast-bottom-right',
                        });
                        $scope.close();
                      })
                      .finally(function () {
                        $scope.loading = false;
                      });
                  }
                }
              };

              $scope.close = function () {
                $modalInstance.close();
              };
            },
          ],
        });
      },
    };
  },
]);
